import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FollowUp, FuProgress } from '../../../models/FollowUpResponse';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { LastValidated } from '../../../models/LastValidated';
import { Module } from '../../../models/Module';
import { DividerModule } from 'primeng/divider';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'app-child-details-modale',
    standalone: true,
    imports: [
        CommonModule,
        TagModule,
        ProgressBarModule,
        DividerModule,
        TranslateModule,
    ],
    templateUrl: './child-details-modale.component.html',
    styleUrl: './child-details-modale.component.scss',
})
export class ChildDetailsModaleComponent {
    @Input() public followUp: FollowUp;
    @Input() public dates: { [userId: string]: LastValidated } = {};
    @Input() public modules: Module[];

    constructor(
        private activeModale: NgbActiveModal,
        public translationService: TranslationService
    ) {}

    validate() {
        this.activeModale.close({ message: 'cancel' });
    }

    getGlobalProgressValueFrom(fu: FollowUp): number {
        return (fu.global_score * 100) / fu.global_max_score;
    }

    getProgressValueFrom(progress: FuProgress): number {
        return (progress.score / progress.max_module_score) * 100;
    }

    getSeverityForLastValidated(
        date: LastValidated
    ):
        | 'success'
        | 'secondary'
        | 'info'
        | 'warn'
        | 'danger'
        | 'contrast'
        | undefined {
        if (date.dayDuration === undefined) {
            return 'danger';
        } else if (date.dayDuration < 4) {
            return 'success';
        } else if (date.dayDuration < 8) {
            return 'warn';
        } else {
            return 'danger';
        }
    }

    getStringForLastValidated(date: LastValidated): string {
        if (date.dayDuration === undefined) {
            return '';
        } else if (date.dayDuration === 0) {
            return this.translationService.instant(
                'modales.childDetails.today'
            );
        } else {
            return this.translationService.instant(
                'modales.childDetails.daysAgo',
                { days: date.dayDuration }
            );
        }
    }

    getModuleName(moduleId: string): string {
        const module = this.modules.find((elt) => elt.module_enum === moduleId);

        return (
            module?.title ??
            this.translationService.instant('modales.childDetails.unknown')
        );
    }
}
